import axios from '@/store/config';
import auth from '@/auth/index';
import VueAxios from 'vue-axios';

export default {
  // state
  state : {
    errorReportFeedback: [],
    isShow: null
  },
  // getters
  getters : {
    errorReportFeedback : state => state.errorReportFeedback,
    isShowReport: state => {
      if(!state.isShow) {
        var ret = {};
        if(state.errorReportFeedback.length > 0) {
          for (var i = 0, len = state.errorReportFeedback.length; i < len; i++) {
            ret[i] = false;
          }
        }
        state.isShow = ret;
      }
      return state.isShow;
    }
  },

  // actions
  actions : {
    getErrorReportFeedback ({ commit }) {
      var _commit = commit;
      return new Promise((resolve, reject) => {
        axios.get('/Applicants/me/errorreports')
        .then(function (response, commit) {
          //Give the response a little massage
          for (var i = 0; i < response.data.length; i++) {
            let _separatorIndex = response.data[i].status.indexOf(' - ');
            if(_separatorIndex > -1) {
              response.data[i].CompletedDateTime = response.data[i].status.slice(_separatorIndex + 3, response.data[i].status.length);
              response.data[i].Status = response.data[i].status.slice(0, _separatorIndex);
            }
          }
          _commit('setErrorReportFeedback', response.data);
          resolve(true);
        })
        .catch(function (error) {
          //console.log(error);
          resolve(false);
        });
      });
    },
    toggleShowReport ({ state, commit }, index) {
      commit('setShowReport', index);
    },
  },

  // mutations
  mutations : {
    setErrorReportFeedback (state, errorReportFeedback) {
      state.errorReportFeedback = errorReportFeedback;
    },
    setShowReport (state, index) {
      state.isShow[index] = !state.isShow[index];
    }
  }
}
